import './BaseRateActiveRates.css';
import React from 'react';

import TerminalSelector from '../../containers/TerminalSelector';
import Waitable from '../Waitable';
import OrganizationSelector from '../../containers/OrganizationSelector';
import COLUMNS from './table_columns';
import TableV2 from '../Table/TableV2';
import { Row, Input, Col, Label, FormGroup } from 'reactstrap';


export default class BaseRateActiveRates extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      clientObject: undefined,
      displayClientRates: false,
      disableClientSelector: true
    };

    this.getRates = this.getRates.bind(this);
    this.onOrgChange = this.onOrgChange.bind(this);
    this.onTerminalChange = this.onTerminalChange.bind(this);
    this.onViewClientRates = this.onViewClientRates.bind(this);
  }

  onTerminalChange(terminalObject) {

    const { dispatchSetUiState } = this.props;
    dispatchSetUiState({
      terminalObject,
      selectedIndexes: [],
      selectedObjects: []
    });
    const { uiState } = this.props;
    let { clientObject } = uiState;
    this.getRates(terminalObject, clientObject);

  }

  onOrgChange(clientObject) {

    const { dispatchSetUiState } = this.props;
    dispatchSetUiState({
      clientObject
    });

    const { uiState } = this.props;
    let { terminalObject } = uiState;
    this.getRates(terminalObject, clientObject);

  }

  getRates(terminalObject, clientObject) {

    let { displayClientRates } = this.state;
    const { dispatchSetUiState, dispatchGetRateSheet } = this.props;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject && displayClientRates ? clientObject.value : null;

    dispatchSetUiState({
      terminalId,
      orgId
    });

    dispatchGetRateSheet({
      terminalId,
      orgId
    }, (err, data) => {

    });
  }


  onViewClientRates(ev) {

    let viewClientRates = ev.target.checked;
    const { dispatchSetUiState, dispatchGetRateSheet } = this.props;
    if (!viewClientRates) {
      dispatchSetUiState({
        clientObject: undefined
      });
    }

    this.setState({
      displayClientRates: viewClientRates,
      disableClientSelector: !viewClientRates
    }, () => {
      const { uiState, } = this.props;
      let { terminalObject, clientObject } = uiState;
      this.getRates(terminalObject, clientObject);
    });
  }

  render() {
    let { disableClientSelector } = this.state;
    let { rateSheet, uiState, dispatchSetUiState, rateData, importSheet } = this.props;
    let { clientObject, terminalObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    return (

      <Row>
        <Col xs='12'>
          <Label>Terminal</Label>
        </Col>
        <Col xs='12' className="pb-3">
          <TerminalSelector
            value={terminalObject}
            terminalId={terminalId}
            onChange={this.onTerminalChange} />
        </Col>
        <Col xs='12' className="pb-3">
          <FormGroup check className="checkbox">
            <Input onClick={this.onViewClientRates} className="form-check-input" type="checkbox" id="checkbox1" name="checkbox1" value="option1" />
            <Label check className="form-check-label" htmlFor="checkbox1">View Client Rates</Label>
          </FormGroup>
        </Col>
        {disableClientSelector ? null :
          <Col xs='12'>
            <Col xs='12' className="pl-0 pr-0">
              <Label>Terminal</Label>
            </Col>
            <Col xs='12' className="pl-0 pr-0 pb-3">
              <OrganizationSelector
                terminalId={terminalId}
                disabled={disableClientSelector}
                //value={clientObject}
                onChange={this.onOrgChange}
              />
            </Col>
          </Col>
        }
        <Col xs='12'>
          <Waitable entities={[rateSheet, importSheet]}>
            <TableV2
              data={rateSheet.get("data") || []}
              columns={COLUMNS.baseRatesDataColumns}
              uiState={uiState}
              dispatchSetUiState={dispatchSetUiState}
            />


          </Waitable>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BaseRates/BaseRateActiveRates.js